import { $, alcance, aviso, el, esc, limpiar, noContesto, num, pedir, puede, rpc, sb, TOPE_SERVIDOR, YO } from './nucleo';
import { cargarAprobaciones } from './aprobaciones';

// ---------- equipos, uno por uno ----------
//
//  La situación y el booleano `disponible` salen de `app.unidades_ocupadas()`
//  (0057, D135), que lee los ítems que retienen equipos COMO DUEÑO: son los
//  mismos para todos. Lo recortado por el alcance de `pedido.ver` son los DATOS
//  del pedido (código, cliente, precio): una fila «Vendida» con el pedido en
//  blanco quiere decir «vendida, en un pedido que no ves».
let UNIDADES: any[] = [], FILTRO_SIT = '';
let ESTADO: 'inicial' | 'ok' | 'error' = 'inicial', E_UNI = '';
//  EL CATÁLOGO DE LA MARCA (`estados_unidad`, 0055). Sirve para ofrecer los
//  estados en la tarjeta de marcar y para saber si la situación de una fila ES
//  una marca o sale de un pedido. Tres estados, como toda lectura (D103).
let ESTADOS: any[] = [], E_ESTADOS: string | null = null;
let ESTADOS_LEIDOS = false;
//  EL TOPE ES EL DEL SERVIDOR (D122). Pedir más de lo que el servidor da es
//  pedir un número que la pantalla después no puede reconocer.
const TOPE = TOPE_SERVIDOR;
//  ¿La lista que se leyó puede no ser toda? Llegó LLENA: mil filas enteras no
//  dicen si son todas.
const cortada = () => UNIDADES.length >= TOPE;

//  EL BUSCADOR, CUANDO LA LISTA ESTÁ CORTADA. Filtrar en el navegador busca
//  sólo entre los mil más nuevos y «Nada con ese filtro» sería una afirmación
//  sobre todos hecha mirando una parte: con la lista cortada se pregunta a la
//  BASE; con la entera se filtra acá. Mínimo tres caracteres.
const MIN_BUSCAR = 3;
type Busqueda = { q: string; estado: 'leyendo' | 'ok' | 'error'; filas: any[]; error: string };
let BUSQUEDA: Busqueda | null = null;
let PEDIDO_BUSQUEDA = 0;
let DEMORA_BUSQUEDA: ReturnType<typeof setTimeout> | null = null;
//  Lo que se le manda a PostgREST adentro de un `or=(…)`: la coma y los
//  paréntesis son SINTAXIS del filtro, y `*`, `%` y `_` son comodines. Un IMEI,
//  código o nombre no los lleva; si se escriben, se sacan en vez de romper.
const limpio = (q: string) => q.replace(/[,()"\\*%_]/g, ' ').trim();
const textoBuscado = () => limpio(($('#buscaUni').value || '').toLowerCase());
const buscaEnLaBase = () => cortada() && textoBuscado().length >= MIN_BUSCAR;

async function buscarEnLaBase(){
  const q = textoBuscado();
  const n = ++PEDIDO_BUSQUEDA;
  BUSQUEDA = { q, estado: 'leyendo', filas: [], error: '' };
  pintarUnidades();
  const patron = `%${q}%`;
  const { data, error } = await pedir(sb.from('v_unidades').select('*')
    .or(['serie','producto','descripcion','cliente','pedido']
          .map(c => `${c}.ilike.${patron}`).join(','))
    .order('id', { ascending: false }).limit(TOPE));
  //  La respuesta VIEJA no pisa a la nueva (la de «351» puede llegar después
  //  de la de «3512»).
  if (n !== PEDIDO_BUSQUEDA) return;
  BUSQUEDA = error ? { q, estado: 'error', filas: [], error: error.message }
                   : { q, estado: 'ok', filas: data || [], error: '' };
  pintarUnidades();
}

function alTeclear(){
  if (DEMORA_BUSQUEDA) clearTimeout(DEMORA_BUSQUEDA);
  DEMORA_BUSQUEDA = null;
  //  Sin nada que buscar en la base, se pinta la lista leída. Una búsqueda en
  //  vuelo no molesta: `pintarUnidades()` sólo la usa si su texto es el escrito.
  if (!buscaEnLaBase()){ pintarUnidades(); return; }
  DEMORA_BUSQUEDA = setTimeout(() => { DEMORA_BUSQUEDA = null; buscarEnLaBase(); }, 300);
}

const veTodosLosPedidos = () => alcance('pedido','ver') === 'todos';

//  ¿La situación de esta fila es la de un PEDIDO? Decide si un pedido en blanco
//  quiere decir «no está en ninguno» o «está en uno que no ves». Se contesta con
//  la fila, sin mirar el alcance: no es «Disponible» y no es el nombre de una marca.
//
//  Si el catálogo no se pudo leer, la marca se reconoce por `vendible`: un
//  equipo marcado nunca está en un pedido vivo, salvo lo que ya salió
//  —«Vendida» o «Anulada»—, que también es de un pedido.
const esMarca = (u: any) => {
  //  Un equipo vendible no tiene marca: el estado «Disponible» del catálogo
  //  se llama igual que la situación del `ELSE`; sin esta línea lo libre
  //  se pintaría como una marca.
  if (u.vendible !== false) return false;
  const e = ESTADOS.find(x => x.codigo === u.estado_codigo);
  return e ? u.situacion === e.nombre
           : !/^(Vendida|Anulada)/.test(String(u.situacion || ''));
};
const enPedido = (u: any) => u.situacion !== 'Disponible' && !esMarca(u);

export async function cargarUnidades(){
  limpiar('#uniMsg');
  //  Las dos columnas del costo se fijan ANTES del `await` y en los dos caminos:
  //  dependen del PERMISO, no de lo que conteste la consulta (una lectura caída
  //  no debe decidir un permiso).
  const veCosto = puede('costo','ver');
  $('#thCosto').style.display  = veCosto ? '' : 'none';
  $('#thMargen').style.display = veCosto ? '' : 'none';
  if (ESTADO === 'inicial')
    $('#tblUnidades').innerHTML =
      `<tr><td colspan="${veCosto ? 8 : 6}" class="vacio">Leyendo los equipos…</td></tr>`;
  //  POR ORDEN DE CARGA (`id`), no por fecha de ingreso: la fecha sale de un
  //  LEFT JOIN a `recepciones` que el RLS tapa (null), y los null van PRIMERO
  //  al ordenar descendente. El `id` es el orden de ingreso y no depende de
  //  ningún permiso.
  const [{ data, error }, cat] = await Promise.all([
    pedir(sb.from('v_unidades').select('*').order('id', { ascending: false }).limit(TOPE)),
    pedir(sb.from('estados_unidad').select('*').order('orden'))]);
  E_ESTADOS = cat.error ? cat.error.message : null;
  ESTADOS = cat.data || [];
  ESTADOS_LEIDOS = true;
  E_UNI  = error?.message || '';
  ESTADO = error ? 'error' : 'ok';
  UNIDADES = data || [];
  if (error){
    //  Se repinta la tabla: dejar la lista anterior con un aviso arriba es
    //  mostrar datos viejos como actuales. El texto del error lo escribe
    //  `pintarUnidades()` y NO se repite acá (dos copias pueden divergir).
    limpiar('#uniMsg');
    //  El resumen por situación se borra (afirmaría un recuento que ya no se
    //  pudo leer) y `FILTRO_SIT` también: su radio ya no existe.
    $('#filtroSituacion').innerHTML = '';
    FILTRO_SIT = '';
    pintarUnidades();
    return;
  }

  //  EL COSTO SE PREGUNTA, NO SE DEDUCE (arriba, antes del `await`): no adivinar
  //  el permiso mirando si los datos traen costo (`app.costo_unidad` devuelve
  //  null sin `costo.ver`, pero también hay listas vacías o unidades sin costo).
  //  `costo.ver` es del rol `dueno` (0050, D115); el admin global lo tiene
  //  sólo con la casilla de Ajustes prendida (D117, D164). Por
  //  eso se pregunta cada vez.
  const sits = [...new Set(UNIDADES.map(u => u.situacion))].sort();
  //  El contador de «Todos» dice CUÁNTAS SE LEYERON; si llegó al tope, lo dice.
  const tope = cortada();
  $('#filtroSituacion').innerHTML =
    `<label><input type="radio" name="fs" value=""${!FILTRO_SIT?' checked':''}> ${
      tope ? `Los últimos ${num(TOPE)} cargados` : `Todos (${UNIDADES.length})`}</label>` +
    sits.map(x => `<label><input type="radio" name="fs" value="${esc(x)}"${
      FILTRO_SIT===x?' checked':''}> ${esc(x)} (${UNIDADES.filter(u=>u.situacion===x).length})</label>`).join('');

  //  Los carteles que explican lo que la tabla no puede decir sola; sólo
  //  cuando hay algo que explicar.
  const partes: string[] = [];
  if (!veTodosLosPedidos())
    partes.push('<div class="hint"><span class="chip c-warn">hay pedidos que no ves</span> '
      + 'La situación de cada equipo es la de verdad, esté en el pedido que esté. Pero '
      + (puede('pedido','ver')
          ? 'tenés <b>pedido.ver</b> con alcance <b>propio</b>, así que '
          : 'te falta <b>pedido.ver</b>, así que ')
      + 'el pedido y el cliente de un equipo que está en un pedido ajeno dicen '
      + '<b>no lo ves</b>.</div>');
  if (alcance('recepcion','ver') !== 'todos')
    partes.push('<div class="hint"><span class="chip c-warn">falta cuándo entró</span> '
      + 'La fecha de ingreso, el proveedor y el remito salen de la recepción, y '
      + (puede('recepcion','ver')
          ? 'sólo ves las que recibiste vos.'
          : 'te falta <b>recepcion.ver</b>.')
      + ' Un «—» en esa columna no quiere decir que no se sepa cuándo entró.</div>');
  if (tope)
    partes.push(`<div class="hint"><span class="chip c-warn">puede haber más</span> `
      + `Se leyeron los últimos ${num(TOPE)} equipos cargados, que es lo máximo que manda `
      + `el servidor de una vez. Los números de cada situación son de esos ${num(TOPE)}. `
      + `El buscador busca en <b>todos</b> los equipos desde ${MIN_BUSCAR} caracteres.</div>`);
  $('#uniMsg').innerHTML = partes.join('');

  //  Con el texto ya escrito: si la lista quedó cortada, la búsqueda se vuelve
  //  a pedir; si quedó entera, se filtra acá.
  //  Una lectura nueva es lo que manda el cartel de «no contestó»: se sabe cómo
  //  quedaron los equipos y la tarjeta se puede volver a ofrecer.
  SIN_RESPUESTA.clear();
  //  La búsqueda se ESPERA: quien relee después de marcar necesita la fila
  //  nueva, no «Buscando…».
  if (buscaEnLaBase()) await buscarEnLaBase();
  else pintarUnidades();
}

$('#filtroSituacion').onchange = e => { FILTRO_SIT = el(e.target).value; pintarUnidades(); };
$('#buscaUni').oninput = alTeclear;

//  El color: verde lo que está bien, rojo lo anulado o dado de baja (salió del
//  depósito), amarillo lo demás. Una marca se pinta por las BANDERAS de su
//  estado, no por su nombre: los nombres del catálogo los pone cada empresa.
const COLOR_SIT = (u: any) => {
  const s = String(u.situacion || '');
  if (esMarca(u)){
    const e = ESTADOS.find(x => x.codigo === u.estado_codigo);
    return e && !e.en_deposito ? 'c-bad' : 'c-warn';
  }
  return s === 'Vendida'           ? 'c-ok'
       : s === 'Disponible'        ? 'c-ok'
       : s.startsWith('Anulada')   ? 'c-bad'
       : s === 'En reparto'        ? 'c-pen' : 'c-warn';
};

//  EL CLIENTE. `v_unidades` llega al cliente por `LEFT JOIN clientes`, que
//  tapa `id in (select app.mis_clientes())` (`app.cliente_es_mio`, 0058). Pero
//  **`pedidos.cliente_id` es NOT NULL**: un cliente en blanco sobre una fila que
//  SÍ trae su pedido quiere decir que no lo podés ver; un guion pelado afirma.
//  Sin pedido, el guion es correcto.
//  EL HUECO DE LA FECHA DE INGRESO tiene DOS causas que la vista no distingue:
//  `unidades.recepcion_id` es nullable (no entró por recepción) y
//  `recepciones_ver` recorta por fila (tapada). **Con la recepción tapada, fecha,
//  proveedor y remito llegan en blanco igual que sin recepción.** Ojo: no
//  decidirlo con `veRec` (propiedad de quien mira, no de la fila) ni por el
//  remito. Es la terna sí · no · **no se sabe**, y lo que no se sabe se dice.
//  Con el alcance entero sí se sabe: sin fecha es que no hay recepción.
const celdaIngreso = (u: any, veRec: boolean) =>
  u.ingresada_en ? new Date(u.ingresada_en).toLocaleDateString('es-AR')
  : veRec ? '<span title="Este equipo no entró por ninguna recepción">—</span>'
  : '<span title="No se sabe: o este equipo no entró por ninguna recepción, '
    + 'o la recepción no la podés ver">—</span>';

const NO_LO_VES = (t: string) =>
  `<td class="hint" title="${esc(t)}"><span class="chip c-warn">no lo ves</span></td>`;
const celdaCliente = (u: any) =>
  u.cliente ? `<td>${esc(u.cliente)}</td>`
  : u.pedido ? NO_LO_VES('Este cliente no lo podés ver')
  //  0057 · el equipo está en un pedido (la situación lo dice) que no ves:
  //  el cliente no está en blanco porque no haya.
  : enPedido(u) ? NO_LO_VES('Está en un pedido que no podés ver')
  : '<td>—</td>';
//  Y el pedido, que es la misma pregunta.
const celdaPedido = (u: any) =>
  u.pedido ? `<td class="mono">${esc(u.pedido)}</td>`
  : enPedido(u) ? NO_LO_VES('Está en un pedido que no podés ver')
  : '<td class="mono">—</td>';

function pintarUnidades(){
  const q = ($('#buscaUni').value || '').toLowerCase();
  const veCosto = puede('costo','ver');
  const veRec   = alcance('recepcion','ver') === 'todos';
  //  De dónde salen las filas: de la búsqueda en la base si la lista está
  //  cortada y hay texto para buscar; si no, de la lista leída.
  const enBase = ESTADO === 'ok' && buscaEnLaBase();
  const b = enBase && BUSQUEDA && BUSQUEDA.q === textoBuscado() ? BUSQUEDA : null;
  const origen = enBase ? (b?.estado === 'ok' ? b.filas : []) : UNIDADES;
  const f = origen.filter(u =>
    (!FILTRO_SIT || u.situacion === FILTRO_SIT) &&
    (enBase || !q || [u.serie, u.producto, u.descripcion, u.cliente, u.pedido]
             .some(x => (x||'').toLowerCase().includes(q))));

  //  El `colspan` son OCHO columnas con el costo a la vista y SEIS sin él
  //  (casi todos no tienen `costo.ver`; D115, D117).
  const cols = puede('costo','ver') ? 8 : 6;
  if (ESTADO === 'inicial'){
    $('#tblUnidades').innerHTML =
      `<tr><td colspan="${cols}" class="vacio">Leyendo los equipos…</td></tr>`;
    return;
  }
  if (ESTADO === 'error'){
    $('#tblUnidades').innerHTML = `<tr><td colspan="${cols}" class="vacio">`
      + `No se pudieron leer los equipos (${esc(E_UNI)}). No quiere decir que no `
      + `haya: no se pudo preguntar.</td></tr>`;
    return;
  }

  if (enBase && (!b || b.estado === 'leyendo')){
    $('#tblUnidades').innerHTML = `<tr><td colspan="${cols}" class="vacio">`
      + `Buscando «${esc(textoBuscado())}» en todos los equipos…</td></tr>`;
    return;
  }
  if (enBase && b!.estado === 'error'){
    $('#tblUnidades').innerHTML = `<tr><td colspan="${cols}" class="vacio">`
      + `No se pudo buscar en todos los equipos (${esc(b!.error)}). No quiere decir que `
      + `no esté: no se pudo preguntar. Volvé a escribir para intentar de nuevo.</td></tr>`;
    return;
  }

  //  Lo que no se puede afirmar del vacío, según de dónde salió la lista.
  const vacio =
      //  Con la búsqueda LLENA, la situación se filtra acá sobre esos mil: un
      //  vacío es de esos mil, no de todos.
      enBase && b!.filas.length >= TOPE
        ? `Ninguno de los ${num(TOPE)} que llegaron está en la situación «${esc(FILTRO_SIT)}»: `
          + 'puede haber entre los demás. Afiná la búsqueda.'
    : enBase ? `Ningún equipo coincide con «${esc(b!.q)}»${FILTRO_SIT
                 ? ` en la situación «${esc(FILTRO_SIT)}»` : ''}.`
    : !UNIDADES.length ? 'Todavía no hay equipos cargados. Se cargan por Recepción.'
    : cortada() ? `Nada entre los últimos ${num(TOPE)} equipos cargados. `
                  + (q.trim() ? `Escribí al menos ${MIN_BUSCAR} caracteres para buscar en todos.`
                              : 'Puede haber entre los cargados antes.')
    : 'Nada con ese filtro';
  //  Y la búsqueda también la corta el servidor.
  const avisoBusqueda = enBase && b!.filas.length >= TOPE
    ? `<tr><td colspan="${cols}" class="hint">Hay más de ${num(TOPE)} equipos que coinciden `
      + `con «${esc(b!.q)}»: se muestran los últimos ${num(TOPE)} cargados. Afiná la búsqueda.</td></tr>`
    : '';

  $('#tblUnidades').innerHTML = avisoBusqueda + (f.map(u => `
    <tr data-serie="${esc(u.serie)}" style="cursor:pointer">
      <td class="mono"><b>${esc(u.serie)}</b></td>
      <td><span class="mono">${esc(u.producto)}</span> ${esc(u.descripcion)}</td>
      <td><span class="chip ${COLOR_SIT(u)}">${esc(u.situacion)}</span>${
        u.motoquero ? ` <span class="hint">${esc(u.motoquero)} · vuelta ${u.vuelta}</span>` : ''}</td>
      ${celdaPedido(u)}
      ${celdaCliente(u)}
      <td class="hint">${celdaIngreso(u, veRec)}</td>
      ${veCosto ? `<td class="num">${u.costo != null ? num(Number(u.costo)) : '—'}</td>
                   <td class="num">${u.margen != null ? `<b>${num(Number(u.margen))}</b>` : '—'}</td>` : ''}
    </tr>`).join('') ||
    `<tr><td colspan="${cols}" class="vacio">${vacio}</td></tr>`);
}

// Un clic en la fila muestra todo lo que le pasó a ese equipo.
//
//  LA SERIE QUE SE ESTÁ MIRANDO, a nivel de módulo. Ojo: no guardar el `<tr>`
//  para usarlo DESPUÉS del `await`: cualquier repintado lo desprende y la
//  respuesta caería en un nodo huérfano; y dos clics seguidos dejarían dos
//  paneles con el mismo id. Se guarda QUÉ se mira, se pinta «leyendo…» enseguida
//  (D103; viaje de hasta siete segundos, D92) y al llegar la respuesta se
//  busca la fila por serie y se descarta si ya no es lo pedido.
let MIRANDO: string | null = null;

const panel = (serie: string, dentro: string) => {
  //  Se busca la fila POR SERIE en el DOM de ahora, no la que se capturó
  //  antes del `await`.
  const fila = $(`#tblUnidades tr[data-serie="${CSS.escape(serie)}"]`);
  if (!fila) return;
  document.getElementById('filaHistorial')?.remove();
  const tr = document.createElement('tr');
  tr.id = 'filaHistorial';
  tr.innerHTML = `<td colspan="${puede('costo','ver') ? 8 : 6}">
    <div class="confirmar">
      <div class="conf-tit">Historial de ${esc(serie)}</div>
      ${dentro}
    </div></td>`;
  fila.after(tr);
};

//  La fila de la lista que se está mirando, por serie: de la búsqueda en la
//  base si es de ahí, o de la lista leída.
//  EL MISMO ORIGEN QUE LA TABLA: una búsqueda vieja que ya no se muestra no
//  puede darle a la tarjeta una fila distinta de la que se ve.
const unidadPorSerie = (serie: string) => {
  const enBase = ESTADO === 'ok' && buscaEnLaBase();
  const b = enBase && BUSQUEDA && BUSQUEDA.q === textoBuscado() && BUSQUEDA.estado === 'ok'
    ? BUSQUEDA.filas : null;
  return (enBase ? (b || []) : UNIDADES).find(u => u.serie === serie) ?? null;
};

// ---------------------------------------------------------------------
//  MARCAR ESTE EQUIPO  (C4-B, 0055 · D130)
// ---------------------------------------------------------------------
//  Lo que el sistema no puede saber de un equipo (falla, caja dañada, baja) lo
//  escribe alguien, con motivo y firma. La puerta es `public.marcar_unidad`: con
//  `unidad.marcar` (el admin) marca directo; sin él, SÓLO hacia un estado no
//  vendible y con un vale aprobado de quien marca, para ESTE equipo y ESTE
//  estado. Volver a vendible lo hace un administrador.
//
//  El botón depende del permiso, el estado elegido y si ya hay un vale. El vale
//  se busca en `v_aprobaciones` ANTES de decidir el botón y otra vez después de
//  cada acción (lo que la pantalla OFRECE también caduca, D108). Si la base
//  contesta 42501 con `hint = 'unidad_no_vendible'`, la tarjeta pasa a «Pedir
//  autorización»: se decide por el hint, no por el texto (D68).
//  Los vales son DE UN EQUIPO: se guardan con su `unidadId`, y una lectura que
//  vuelve cuando ya se mira otro equipo no pisa la de éste.
type Vales = { unidadId: number; estado: 'leyendo' | 'ok' | 'error'; filas: any[]; error: string };
let VALES: Vales | null = null;
//  Lo que la base dijo que no sirve, por equipo, estado y VALE: tras un 42501
//  con el hint, ESE vale no se vuelve a ofrecer (la base manda, D110), pero uno
//  nuevo sí. La clave con «-» es la del intento sin vale leído. Ojo: la clave no
//  puede ser sólo equipo y estado, o un rechazo inutiliza el vale aprobado después.
const SIN_VALE = new Set<string>();
//  EL ACTO EN VIAJE (D125): mientras una marca o un pedido de autorización
//  viajan, la tarjeta que se vuelva a pintar no ofrece el botón otra vez.
const EN_VIAJE = new Set<number>();
//  Y el que no contestó (D91): puede haber quedado hecho. El botón no vuelve
//  hasta que se relee el equipo (volver a entrar a la pestaña).
const SIN_RESPUESTA = new Set<number>();

let PEDIDO_VALES = 0;
async function leerVales(unidadId: number){
  const n = ++PEDIDO_VALES;
  VALES = { unidadId, estado: 'leyendo', filas: [], error: '' };
  const { data, error } = await pedir(sb.from('v_aprobaciones').select('*')
    .eq('tipo', 'unidad_no_vendible').eq('referencia_tipo', 'unidad')
    .eq('referencia_id', unidadId).eq('solicitado_por', YO?.id ?? -1));
  //  La respuesta VIEJA no pisa a la nueva.
  if (n !== PEDIDO_VALES) return;
  VALES = error ? { unidadId, estado: 'error', filas: [], error: error.message }
                : { unidadId, estado: 'ok', filas: data || [], error: '' };
}

//  Qué ofrece la tarjeta para este equipo y este estado destino.
type Modo = { boton: 'marcar' | 'autorizado' | 'pedir' | null; vale?: number; nota: string };
function modoDe(u: any, destino: any): Modo {
  if (!destino) return { boton: null, nota: '' };
  if (puede('unidad','marcar')) return { boton: 'marcar', nota: '' };
  if (destino.vendible)
    return { boton: null, nota: 'Volver un equipo a vendible lo hace un administrador.' };
  const clave = `${u.id}:${destino.codigo}`;
  //  Los de ESTE equipo: `abrir()` pide los suyos antes de pintar, y una
  //  respuesta vieja de otro no llega a pisarlos (`leerVales`).
  const mios = VALES;
  const deEste = (mios?.filas || []).filter(a => a.datos?.estado === destino.codigo);
  const vale = deEste.find(a => a.vale_sin_usar && !SIN_VALE.has(`${clave}:${a.id}`));
  if (vale)
    return { boton: 'autorizado', vale: Number(vale.id),
             nota: 'Tenés una autorización aprobada para marcarlo así.' };
  if (deEste.some(a => a.es_pendiente))
    return { boton: null, nota: 'Ya pediste esta autorización: está esperando respuesta. '
      + 'La vas a ver en Aprobaciones.' };
  if (!mios || mios.estado === 'leyendo')
    return { boton: null, nota: 'Buscando si ya tenés una autorización…' };
  //  Sin poder leer los vales, NO SE SABE si hay uno: se ofrece marcar
  //  igual, y la base lo busca sola (si no hay, contesta con el hint y la
  //  tarjeta pasa a «Pedir»).
  if (mios.estado === 'error' && !SIN_VALE.has(`${clave}:-`))
    return { boton: 'marcar', nota: `No se pudo saber si ya tenés una autorización (${mios.error}). `
      + 'Si la tenés, marcarlo la usa; si no, te lo va a decir.' };
  return { boton: 'pedir', nota: 'Sin permiso para marcarlo directo: se le pide a un administrador. '
    + 'Cuando lo apruebe, volvé acá y marcalo.' };
}

const ROTULO = { marcar: 'Marcar', autorizado: 'Marcar (autorizado)', pedir: 'Pedir autorización' };

function tarjetaMarcar(u: any): string {
  const tit = '<div class="conf-tit" style="margin-top:0.706rem">Marcar este equipo</div>';
  if (!ESTADOS_LEIDOS)
    return tit + '<p class="conf-txt">Leyendo los estados posibles…</p>';
  if (E_ESTADOS !== null)
    return tit + `<p class="conf-txt">No se pudo leer la lista de estados (${esc(E_ESTADOS)}): `
      + 'no se puede ofrecer marcarlo. Volvé a entrar a la pestaña para intentar de nuevo.</p>';
  //  Una marca sólo se pone sobre un equipo LIBRE (D130). Lo dice la fila, que
  //  desde la 0057 no depende de qué pedidos se ven.
  if (enPedido(u))
    return tit + `<p class="conf-txt">Está en un pedido («${esc(u.situacion)}»): `
      + 'se marca cuando quede libre —cuando salga del pedido o, si ya se entregó, '
      + 'cuando vuelva—.</p>';
  if (SIN_RESPUESTA.has(Number(u.id)))
    return tit + '<p class="conf-txt">La última vez la base no llegó a contestar, así que no se '
      + 'sabe si quedó hecho. Volvé a entrar a la pestaña para ver cómo quedó el equipo.</p>';
  const opciones = ESTADOS.filter(e => e.activo && e.codigo !== u.estado_codigo);
  if (!opciones.length)
    return tit + '<p class="conf-txt">No hay otro estado activo al que pasarlo.</p>';
  return tit + `
    <div class="grid g3" style="margin-top:0.353rem">
      <label>Pasarlo a
        <select id="marcaEstado">${opciones.map(e =>
          `<option value="${esc(e.codigo)}">${esc(e.nombre)}${e.vendible ? '' : ' (no se vende)'}</option>`).join('')}
        </select></label>
      <label>Por qué <input id="marcaMotivo" placeholder="no carga, la caja vino abollada…"></label>
    </div>
    <p class="hint" id="marcaNota"></p>
    <div class="fila-acc"><button class="b b-pri" id="marcaOk"></button></div>
    <div id="marcaMsg"></div>`;
}

//  Pinta el botón y la nota según el estado elegido. Se llama al abrir, al
//  cambiar el estado y después de cada acción.
function pintarBoton(u: any){
  const sel = $('#marcaEstado'), btn = $('#marcaOk');
  if (!sel || !btn) return;
  const destino = ESTADOS.find(e => e.codigo === sel.value);
  const m = modoDe(u, destino);
  $('#marcaNota').textContent = m.nota;
  btn.style.display = m.boton ? '' : 'none';
  btn.dataset.modo = m.boton || '';
  btn.dataset.vale = m.vale != null ? String(m.vale) : '';
  const viaja = EN_VIAJE.has(Number(u.id));
  btn.disabled = viaja;
  btn.textContent = viaja ? 'Esperando la respuesta…' : (m.boton ? ROTULO[m.boton] : '');
}

//  El resultado de un acto cuya tarjeta ya no está (se cerró el panel, se
//  abrió otro equipo, se repintó la lista): se cuenta en el cartel FIJO de
//  la pantalla, que no pertenece a ninguna fila.
const contarSuelto = (tipo: string, texto: string) => aviso('#uniMarcaMsg', tipo, texto);

function conectarTarjeta(u: any){
  const sel = $('#marcaEstado'), btn = $('#marcaOk');
  if (!sel || !btn) return;
  sel.onchange = () => { limpiar('#marcaMsg'); pintarBoton(u); };
  pintarBoton(u);
  btn.onclick = async () => {
    const tarjeta = btn.closest('.confirmar');
    const destino = ESTADOS.find(e => e.codigo === sel.value);
    const motivo = ($('#marcaMotivo').value || '').trim();
    const modo = btn.dataset.modo, vale = btn.dataset.vale;
    limpiar('#marcaMsg'); limpiar('#uniMarcaMsg');
    //  El motivo lo pide la base en los dos caminos; se dice antes de viajar.
    if (!motivo) return aviso('#marcaMsg', 'bad', modo === 'pedir'
      ? 'Escribí por qué: es lo que va a leer quien autoriza.'
      : 'Decí por qué: es lo que se lee después en la historia del equipo.');
    const id = Number(u.id), serie = u.serie;
    EN_VIAJE.add(id); pintarBoton(u);
    const { data, error } = modo === 'pedir'
      ? await rpc('pedir_aprobacion', {
          p_tipo: 'unidad_no_vendible', p_motivo: motivo, p_monto: null as any,
          p_referencia_tipo: 'unidad', p_referencia_id: id,
          p_datos: { estado: destino.codigo } })
      : await rpc('marcar_unidad', {
          p_unidad_id: id, p_estado: destino.codigo, p_motivo: motivo,
          p_vale: vale ? Number(vale) : null as any });
    EN_VIAJE.delete(id);
    if (noContesto(error)) SIN_RESPUESTA.add(id);
    const sigue = !!tarjeta?.isConnected && MIRANDO === serie;
    const que = modo === 'pedir' ? `La autorización para marcar ${serie} que estabas pidiendo: `
                                 : `La marca de ${serie}: `;
    if (error){
      //  EL HINT, no el texto (D68): sin autorización, la tarjeta pasa a
      //  «Pedir autorización» para este equipo y este estado.
      if (error.code === '42501' && error.hint === 'unidad_no_vendible')
        SIN_VALE.add(`${id}:${destino.codigo}:${vale || '-'}`);
      if (!sigue) return contarSuelto('bad', que + error.message);
      aviso('#marcaMsg', 'bad', error.message);
      if (noContesto(error)){ $('#marcaOk').disabled = true; return; }
      pintarBoton(u);
      return;
    }
    if (modo === 'pedir'){
      //  Se relee lo que la tarjeta ofrece: ahora hay una pendiente.
      await leerVales(id);
      cargarAprobaciones();
      if (!sigue || MIRANDO !== serie)
        return contarSuelto('ok', que + (data?.mensaje || 'pedida. Esperá la respuesta.'));
      pintarBoton(u);
      aviso('#marcaMsg', 'ok', data?.mensaje || 'Pedida. Esperá la respuesta.');
      return;
    }
    //  MARCÓ: el mensaje va al cartel fijo (el panel se rearma), la lista se
    //  relee y el panel se reabre con la historia nueva, salvo que mientras
    //  tanto se haya abierto otro equipo.
    contarSuelto('ok', `${serie}: ${data?.mensaje || 'marcado.'}`);
    if (vale) cargarAprobaciones();
    const mirabaEste = MIRANDO === serie;
    await cargarUnidades();
    if (mirabaEste && MIRANDO === serie){ MIRANDO = null; abrir(serie); }
  };
}

async function abrir(serie: string){
  MIRANDO = serie;
  panel(serie, '<p class="conf-txt">Leyendo el historial…</p>');
  const u = unidadPorSerie(serie);
  //  El vale se busca sólo si hace falta (con el permiso no hay nada que buscar).
  const [{ data, error }] = await Promise.all([
    //  EL `error` NO SE DESCARTA: una lectura caída no es una lista vacía.
    pedir(sb.from('v_historial_unidad').select('*').eq('serie', serie).order('ocurrido_en')),
    u && !puede('unidad','marcar') ? leerVales(Number(u.id)) : Promise.resolve()]);
  //  Si mientras viajaba se cerró el panel o se abrió otro equipo, no se pinta.
  if (MIRANDO !== serie) return;
  //  Y el vacío tampoco afirma solo: el historial de pedidos llega por JOIN
  //  INTERNO a `pedidos`, y con el alcance recortado desaparecen los que no se
  //  ven. Las MARCAS no pasan por ahí (0055): se ven siempre.
  const historial =
      error ? `<p class="conf-txt">No se pudo leer el historial (${esc(error.message)}). `
              + `No quiere decir que no tenga: no se pudo preguntar.</p>`
    : (data||[]).length ? `<table style="margin-top:0.353rem">
        <thead><tr><th>Cuándo</th><th>Qué pasó</th><th>Pedido</th><th>Motivo</th><th>Quién</th></tr></thead>
        <tbody>${data.map(h => `<tr>
          <td class="hint">${new Date(h.ocurrido_en).toLocaleString('es-AR')}</td>
          <td>${h.tipo === 'marca' ? `Marcado «${esc(h.estado)}»` : esc(h.estado || h.tipo)}</td>
          <td class="mono">${esc(h.pedido || '—')}</td>
          <td>${esc(h.motivo || '—')}</td>
          <td>${esc(h.quien || '—')}</td></tr>`).join('')}</tbody></table>`
      + (veTodosLosPedidos() ? '' : '<p class="hint">Sólo figuran los pedidos que podés ver.</p>')
    : veTodosLosPedidos()
      ? '<p class="conf-txt">Todavía no se movió de su ingreso.</p>'
      : '<p class="conf-txt">No hay nada que puedas ver. El historial de un equipo '
        + 'sale de los pedidos y de sus marcas, y de los pedidos ves sólo los tuyos: '
        + 'puede haberse movido y no figurar acá.</p>';
  //  La tarjeta, sólo si la fila está en la lista (la búsqueda o la lista
  //  leída): sin la fila no se sabe su estado, y marcar a ciegas no.
  panel(serie, historial + (u ? tarjetaMarcar(u) : ''));
  if (u) conectarTarjeta(u);
}

$('#tblUnidades').onclick = async e => {
  //  Un clic ADENTRO del panel (el select, el motivo, el botón) no es un clic
  //  en una fila: sin esto, elegir un estado cerraba el panel.
  if (el(e.target).closest('#filaHistorial')) return;
  const fila = el(e.target).closest('[data-serie]');
  const abierto = document.getElementById('filaHistorial');
  abierto?.remove();
  if (!fila){ MIRANDO = null; return; }

  const serie = fila.dataset.serie;
  //  Un segundo clic en la MISMA fila la cierra, PERO SÓLO SI EL PANEL ESTÁ: un
  //  repintado de la lista se lleva el panel y deja `MIRANDO` puesto.
  if (MIRANDO === serie && abierto){ MIRANDO = null; return; }
  limpiar('#uniMarcaMsg');
  abrir(serie);
};
